exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#refreshButton[data-v-56c25c76] {\n  position: fixed;\n  top: 50px;\n  right: 30px;\n  width: 40px;\n  height: 40px;\n  font-size: 16px;\n\n  border-radius: 50%;\n  border-style: none;\n  box-shadow:5px 5px 1px 0px #555555;\n  margin: auto;\n  color: white;\n  opacity: 0.5;\n  z-index: 1002;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-56c25c76","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/RefreshButton.vue
// module id = 517
// module chunks = 0